import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import "./Breadcrumbs.scss";
import { PreservedLink as Link } from "./PreservedLink";

const Breadcrumbs = ({ items = [] }) => {
  const colorMode = useSelector((state) => state.ui.colorMode);

  return (
    <nav aria-label="breadcrumb" className={`breadcrumbs ${colorMode}`}>
      <ul>
        <li>
          <Link to="/">Homepage</Link>
        </li>
        {items.map((item, index) => (
          <li key={index}>
            {item.link ? (
              <Link to={item.link}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string
  }))
};

export default Breadcrumbs;
